import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Login from '@/views/Login.vue';
import SignUp from '@/views/SignUp.vue';
import Users from '@/views/Users.vue';
import RedMatCalculationsIndex from '@/views/RedMatCalculation/Index.vue';
import RedMatCalculationEdit from '@/views/RedMatCalculation/Edit.vue';
import RedMatCalculationResults from '@/views/RedMatCalculation/Results.vue';
import store from '@/store';
import {
  LOGIN,
  SIGNUP,
  USERS,
  RED_MAT_CALCULATIONS,
  HOME,
  RED_MAT_CALCULATION_EDIT,
  RED_MAT_CALCULATION_RESULTS,
} from './route-names';
import { IS_NEW, HAS_RESULT } from '../use-cases/red-mat-calculation/RedMatCalculationModule';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: HOME,
    redirect: {
      name: RED_MAT_CALCULATIONS,
    },
  },
  {
    path: '/login',
    name: LOGIN,
    component: Login,
  },
  {
    path: '/signup',
    name: SIGNUP,
    component: SignUp,
  },
  {
    path: '/users',
    name: USERS,
    component: Users,
    beforeEnter: (to, from, next) => {
      if (store.getters.userRole === 'Admin') {
        next();
      } else {
        next({ name: HOME });
      }
    },
  },
  {
    path: '/red-mat-calculations',
    name: RED_MAT_CALCULATIONS,
    component: RedMatCalculationsIndex,
  },
  {
    path: '/red-mat-calculations/edit',
    name: RED_MAT_CALCULATION_EDIT,
    component: RedMatCalculationEdit,
    beforeEnter: (to, from, next) => {
      if (store.getters[IS_NEW]) {
        next({ name: RED_MAT_CALCULATIONS });
      } else {
        next();
      }
    },
  },
  {
    path: '/red-mat-calculations/results',
    name: RED_MAT_CALCULATION_RESULTS,
    component: RedMatCalculationResults,
    beforeEnter: (to, from, next) => {
      if (store.getters[IS_NEW] || !store.getters[HAS_RESULT]) {
        next({ name: RED_MAT_CALCULATIONS });
      } else {
        next();
      }
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (store.getters.isAuthenticated) {
    next();
  } else if (to.name === LOGIN || to.name === SIGNUP) {
    next();
  } else {
    next({ name: LOGIN });
  }
});

export default router;
